export function isDev() {
    return process.env.REACT_APP_ENV === "development";
}
